import React from "react";
import Report from "../documents/EEA.pdf";
import Nav from "./nav";
import Footer from "./footer";
import "../css/report.css";

const DocumentViewer = () => {
  const fileUrl = Report;

  return (
    <div className="document-viewer-container">
      <Nav />
      
      {/* Enhanced Hero Section */}
      <div 
        className="report-hero-section"
        
      >
        <div className="hero-content">
          <h1>EnergyX Africa 2023 Impact Report</h1>
         
          <p className="hero-subtitle">
          Where Ideas Ignite and Futures Are Powered
          </p>
          <a href="#reportPdf">
          <button className="cta-button">EnergyX Africa 2023 Impact Report Preview</button>
 
          </a>
          <div className="scroll-indicator">
            <span></span>
            <div className="scroll-text">SCROLL TO EXPLORE</div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="document-content">
        <div className="container">
          {/* Report Summary */}
          <div className="report-summary">
            <h2>Key Highlights</h2>
            <div className="summary-grid">
              <div className="summary-card">
                <div className="summary-icon">📊</div>
                <h3>Industry Insights</h3>
                <p>Analysis of current energy trends and future projections</p>
              </div>
              <div className="summary-card">
                <div className="summary-icon">👥</div>
                <h3>Attendee Statistics</h3>
                <p>Breakdown of participation </p>
              </div>
              <div className="summary-card">
                <div className="summary-icon">💡</div>
                <h3>Innovation Showcase</h3>
                <p>Cutting-edge technologies presented </p>
              </div>
              <div className="summary-card">
                <div className="summary-icon">🎯</div>
                <h3>Key Takeaways</h3>
                <p>Actionable insights for energy sector stakeholders</p>
              </div>
            </div>
          </div>

          {/* Document Viewer */}
          <div className="document-viewer" id="reportPdf">
            <h2>EnergyX Africa 2023 Impact Report Preview</h2>
            <p className="viewer-description">
              Browse through the report below or download the full PDF version
            </p>
            
            <div className="pdf-container">
              <iframe
                src={`${fileUrl}#view=fitH`}
                className="pdf-iframe"
                title="EnergyX 2023 Event Report"
              />
            </div>

            <div className="download-section">
              <a 
                href={fileUrl} 
                download="EnergyX_2023_Event_Report.pdf"
                className="download-button"
              >
                <span>Download Full Report</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 16L7 11L8.41 9.59L12 13.17L15.59 9.59L17 11L12 16Z" fill="currentColor"/>
                  <path d="M5 22H19C20.1 22 21 21.1 21 20V18H19V20H5V18H3V20C3 21.1 3.9 22 5 22Z" fill="currentColor"/>
                </svg>
              </a>
              <p className="file-info">PDF Document • 15MB</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DocumentViewer;